import { colors, breakpoints } from '@web-for-marketing/react-ui';

export const blogCategoryStyles = {
    mainHeader: {
        marginBottom: '4.8rem',
        [`@media (max-width: ${breakpoints.md})`]: {
            marginBottom: '2rem',
        },
        [`@media (max-width: ${breakpoints.sm})`]: {
            marginBottom: '1.6rem',
        },
    },
    sectionTitle: {
        marginBottom: '3.2rem',
        [`@media (max-width: ${breakpoints.sm})`]: {
            marginBottom: '1.6rem',
        },
    },
    newestPosts: {
        backgroundColor: colors.background.lighter,
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
} as const;
